import { render, staticRenderFns } from "./AboutUsSwiper.vue?vue&type=template&id=46ae84d0&scoped=true"
import script from "./AboutUsSwiper.vue?vue&type=script&lang=js"
export * from "./AboutUsSwiper.vue?vue&type=script&lang=js"
import style0 from "./AboutUsSwiper.vue?vue&type=style&index=0&id=46ae84d0&prod&lang=css"
import style1 from "./AboutUsSwiper.vue?vue&type=style&index=1&id=46ae84d0&prod&scoped=scoped&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "46ae84d0",
  null
  
)

export default component.exports